import { DatePicker, Divider, Select, Transfer } from "@neonumy/neonumy-ui";
import { Col, Form, Row } from "antd5";
import { TransferItem } from "antd5/lib/transfer";
import { useTranslation } from "react-i18next";
import { DATE_PICKER_POPUP_ALIGN } from "views/Collaborators/utils/datePicker";
import { useNewUserWorkSettings } from "./hooks/useNewUserWorkSettings";

interface NewUserWorkSettigsProps {
  workShiftOptions: Option[];
  disabled: boolean;
  isNewraiUser: boolean;
}

export default function NewUserWorkSettigs({
  workShiftOptions,
  disabled,
  isNewraiUser,
}: NewUserWorkSettigsProps) {
  const { t } = useTranslation();
  const { accounfingFirmsData, filterOption } = useNewUserWorkSettings();

  return (
    <>
      <Divider />
      <h4>{t("Accesses")}</h4>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item
            label={t("Accounting firms")}
            name="accountingFirms"
            valuePropName="targetKeys"
            rules={[{ required: true }]}
          >
            <Transfer
              dataSource={accounfingFirmsData}
              filterOption={filterOption}
              showSearch
              oneWay
              render={(item: TransferItem) => item.title ?? ""}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        {/* A Newrai user has it in SettingsUserNewrai. */}
        {!isNewraiUser && (
          <Col lg={6} xs={24}>
            <Form.Item label={t("Work shift")} name="workShift">
              <Select options={workShiftOptions} disabled={disabled} />
            </Form.Item>
          </Col>
        )}
        <Col lg={6} xs={24}>
          <Form.Item label={t("Work time")} name="workTime">
            <DatePicker
              picker="time"
              disabled={disabled}
              format="HH:mm"
              popupAlign={DATE_PICKER_POPUP_ALIGN}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
